import React from 'react';
import Img from "gatsby-image";
import Lightbox from 'lightbox-react';
import 'lightbox-react/style.css';

export default class DpcLightboxContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {showLightbox: false, index: 0};
        this.images = this.props.images.map(image => {
            return {
                alt: image.field_alt,
                image: image.relationships.image.localFile.childImageSharp.fluid.src,
                title: image.field_titolo_esteso,
                didascalia: image.field_didascalia
            }
        });
    }

    openLightBox = (index) => {
        this.setState({
            showLightbox: true,
            index
        })
    };

    render() {
        const { index, showLightbox } = this.state;
        return (
            <div id="reactLightboxRoot">
                <div className="react-lightbox-app">
                    <div className="react-lightbox-gallery row">
                        {this.images.map((item, i) => {
                            return (
                                <div className="col-12 col-md-6 col-xl-4">
                                    <div className="card-wrapper card-space">
                                        <div className="card card-img">
                                            <div className="img-responsive-wrapper">
                                                <div className="img-responsive" onClick={() => this.openLightBox(i)}>
                                                    <figure className="img-wrapper">
                                                        <figcaption className="sr-only">{item.didascalia}</figcaption>
                                                        <img alt={item.alt}
                                                             src={item.image}/>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {showLightbox &&
                    <Lightbox
                        mainSrc={this.images[index].image}
                        nextSrc={this.images[(index + 1) % this.images.length].image}
                        prevSrc={this.images[(index + this.images.length - 1) % this.images.length].image}
                        onCloseRequest={() => this.setState({ showLightbox: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                        index: (index + this.images.length - 1) % this.images.length,
                    })
                    }
                        onMoveNextRequest={() =>
                        this.setState({
                            index: (index + 1) % this.images.length,
                    })
                    }
                        imageTitle={this.images[index].title}
                        imageCaption={this.images[index].didascalia}
                        />
                    }
                </div>
            </div>
        )
    }
}
